export const STATUS = {
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  TRIAL: 'trialing',
  PENDING: 'pending',
  CANCELED: 'canceled',
};

export const ACTIVE_STATUSES = [STATUS.ACTIVE, STATUS.PAST_DUE, STATUS.TRIAL];
